import React from 'react';
import { Link } from 'react-router-dom';

const InsufficientCreditsPopup = ({ 
  isOpen, 
  onClose, 
  currentBalance, 
  requiredCredits, 
  shortfall, 
  actionName 
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 shadow">
          <div className="modal-header bg-danger text-white">
            <h5 className="modal-title">
              <i className="fas fa-exclamation-triangle me-2"></i>
              Insufficient Credits
            </h5>
            <button 
              type="button" 
              className="btn-close btn-close-white" 
              onClick={onClose}
            ></button>
          </div>
          
          <div className="modal-body">
            <div className="text-center mb-4">
              <div className="display-4 text-danger mb-3">
                <i className="fas fa-credit-card"></i>
              </div>
              <h4 className="text-dark mb-3">Not Enough Credits</h4>
              <p className="text-muted">
                You don't have enough credits to perform this action.
              </p>
            </div>

            <div className="row g-3 mb-4">
              <div className="col-6">
                <div className="card bg-light border-0">
                  <div className="card-body text-center">
                    <div className="h5 text-primary mb-1">{currentBalance}</div>
                    <small className="text-muted">Current Balance</small>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="card bg-light border-0">
                  <div className="card-body text-center">
                    <div className="h5 text-danger mb-1">{requiredCredits}</div>
                    <small className="text-muted">Required Credits</small>
                  </div>
                </div>
              </div>
            </div>

            <div className="alert alert-warning">
              <div className="d-flex align-items-center">
                <i className="fas fa-info-circle me-2"></i>
                <div>
                  <strong>Action:</strong> {actionName}<br/>
                  <strong>Shortfall:</strong> {shortfall} credits needed
                </div>
              </div>
            </div>

            <div className="d-grid gap-2">
              <Link 
                to="/plans" 
                className="btn btn-primary btn-lg"
                onClick={onClose}
              >
                <i className="fas fa-shopping-cart me-2"></i>
                Buy More Credits
              </Link>
              <button 
                type="button" 
                className="btn btn-outline-secondary"
                onClick={onClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsufficientCreditsPopup;
